<nav>
  <ul
    role="menubar"
    class="flex justify-between items-center vip-header-menu-principal vip-color-first-default"
  >
    <li
      vipDropdown
      *ngIf="departamentos.length > 0"
      role="none"
      tabindex="0"
      (openChange)="dropdownDepartamentosIsOpen = $event"
    >
      <button
        vipDropdownButton
        data-cy="header-departamentos"
        class="vip-departamentos-toggle"
        [attr.aria-expanded]="dropdownDepartamentosIsOpen"
        aria-haspopup="true"
      >
        <i class="icon-apps text-3xl mr-4"></i>
        <span class="font-bold text-sm">Departamentos</span>
        <i
          class="icon-expand_more text-3xl ml-1"
          [class.expanded]="dropdownDepartamentosIsOpen"
        ></i>
      </button>

      <vip-dropdown-departamentos
        class="z-50"
        vipDropdownContent
        [addClass]="false"
        [items]="departamentos"
        (itemClick)="itemClick($event)"
      ></vip-dropdown-departamentos>
    </li>

    <li
      class="vip-vertical-bar"
      *ngIf="departamentos.length > 0"
      role="none"
    ></li>

    <div *ngFor="let item of options; let idx = index" class="h-full mt-1">
      <vip-custom-link
        [url]="buildUrl(item)"
        [openInNewTab]="isExternal(item)"
        [useHref]="isExternal(item)"
        (click)="setActive(idx, item)"
      >
        <li
          role="none"
          data-cy="link"
          class="itens-submenu"
          [ngClass]="{ 'active-menu-principal': activeIndex === idx }"
        >
          <span class="text-sm" data-cy="menu-item">
            {{ getMenuOptionValue(idx, 'label') }}
          </span>
        </li>
      </vip-custom-link>
    </div>
  </ul>
</nav>
